import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Form, Button, Spinner } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

import { FormField, SelectFormField } from "../../../utils/FormFields";
import {InstructionTarget } from "../Account/types";
import { Combobox, Field, Symbol } from "../../Modal/Order/Field/Field";

const canSubmit = (ra, bankAccounts) => {
    const condition1 = ra.AccountInstructionType!="" && ra.AccountInstructionsCurrency!="" && ra.AccountInstructionTarget!="";
    const condition2 = (ra.AccountInstructionTarget == "Reinvest" && ra.AccountInstructionAssetId!="" &&
       ra.AccountInstructionAssetId!=0
    );
    const hasSelectedBankAccount = (bankAccounts || []).some((a) =>
        a.BankAccountCurrency == ra.AccountInstructionsCurrency &&
        a.BankAccountItemId == ra.AccountInstructionBankAccountItemId
    );
    const condition3 = (ra.AccountInstructionTarget == "Withdraw" && hasSelectedBankAccount &&
                        ra.AccountInstructionBankAccountItemId!="" && ra.AccountInstructionBankAccountItemId!=0
    );
    if (condition1 && (condition2 || condition3)) {
        return true;
    }
};

const ModalInstruction = ({ open, instruction, toggle, saving, bankAccounts, onSave, onChange, currencies, services, editMode }) => {

    const CorporateEventType= {'Coupon':'Coupon',
    'Dividend':'Dividend',
    'Sink':'Sink',
    'Maturity':'Maturity',
    }
    const bankAccount = (bankAccounts || []).filter((a) => a.BankAccountCurrency == instruction.AccountInstructionsCurrency);
    const selectedBankAccountExists = bankAccount.some(
      (a) => a.BankAccountItemId == instruction.AccountInstructionBankAccountItemId
    );
    const bankAccountValue = selectedBankAccountExists ? instruction.AccountInstructionBankAccountItemId : -1;





  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>Instructions</ModalHeader>
      <ModalBody>
        <Form>
        
          <SelectFormField
            label="Type: "
            name="AccountInstructionType"
            value={instruction.AccountInstructionType}
            selectItems={Object.keys(CorporateEventType)}
            getSelectItemId={(i) => i}
            getSelectItemName={(i) => CorporateEventType[i]}
            onChange={onChange}
            disabled={editMode}
          />
          {currencies ? (
            <SelectFormField
              label="Currency: "
              name="AccountInstructionsCurrency"
              onChange={onChange}
              value={instruction.AccountInstructionsCurrency}
              selectItems={currencies}
              getSelectItemId={(i) => i.currencyId}
              getSelectItemName={(i) => i.currencyISO}
              disabled={editMode}
            />
          ) : (
            <Spinner size="sm" />
          )}
          <SelectFormField
            label="Target: "
            value={instruction.AccountInstructionTarget}
            name="AccountInstructionTarget"
            onChange={onChange}
            selectItems={Object.keys(InstructionTarget)}
            getSelectItemId={(i) => i}
            getSelectItemName={(i) => InstructionTarget[i]}
          />
          {instruction.AccountInstructionTarget == "Reinvest" && (
            <div>
              <label
                style={{
                  fontWeight: 500,
                  fontSize: "15px",
                  display: "block",
                  color: "black",
                }}
              >
                Fund:{" "}
              </label>
              <Symbol
                form={"Mutual Funds"}
                onChange={(v) => onChange("AccountInstructionAssetId" ,parseInt(v.AssetId), v.SettCurrencyName, v.AssetTicker)}
                placeholder={"Symbol"}
                hideInfo={true}
                disabled={false}
                value={instruction.AccountInstructionAssetticker}
                description={instruction.AssetDescription}
                assetid={instruction.AccountInstructionAssetId}
                attrId={"AssetId"}
                attrTicker={"AssetTicker"}
                attrCurrency={"SettCurrencyName"}
                attrDescription={"AssetDescription"}
                {...services}
              />
            </div>
          )}
          {instruction.AccountInstructionTarget == "Withdraw" && (
            <div>
                 <label
                style={{
                  fontWeight: 500,
                  fontSize: "15px",
                  display: "block",
                  color: "black",
                }}
              >
                Bank Account:{" "}
              </label>
             <Combobox
            
             value={bankAccountValue}
           
             items={[
               ...(selectedBankAccountExists ? [{ id: -1, description: "" }] : []),
               ...bankAccount.map((a) => ({
                 id: a.BankAccountItemId,
                 description: `${a.BankAccountName} - ${a.BankAccountNumber}`,
               })),
             ]}
             disabled={instruction.AccountInstructionTarget != "Withdraw" || instruction.AccountInstructionsCurrency==""}
             onChange={(id) =>
                onChange("AccountInstructionBankAccountItemId", id
               )
             }
             emptyLabel={""}
           />
           </div>
          )}

          <FormField
            label="Min: "
            name="AccountInstructionMin"
            type="number"
            onChange={onChange}
            value={instruction.AccountInstructionMin}
          />
          <FormField
            label="Max: "
            name="AccountInstructionMax"
            type="number"
            onChange={onChange}
            value={instruction.AccountInstructionMax}
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={saving}
          disabled={!canSubmit(instruction, bankAccounts)}
          onClick={onSave}
          data-style={EXPAND_RIGHT}
        >
          {saving ? " Saving" : " Save"}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

export default ModalInstruction;
